import { gql } from "@apollo/client";

export const linkedCasePropertyValueFragment = gql`
  fragment LinkedCasePropertyValueFragment on PropertyValue {
    value
    property {
      code
      businessType
      confListCode
    }
  }
`;
